import { createFileRoute, notFound, redirect } from "@tanstack/react-router"

import { cleanEmptyParams } from "@/utilities/etc"
import { fetchWelcomeToken } from "@/utilities/hooks/queries/shared"

// HEY YOU THIS ROUTE SHOULD NEVER CHANGE
// People get texted a link to this page for their confirmation
// Route: /confirmation

export const Route = createFileRoute("/confirmation")({
  validateSearch: (
    search: Record<string, unknown>
  ): {
    qr: string
    session: string
    key: string
  } => {
    return cleanEmptyParams({
      qr: (search.qr as string) || "",
      session: (search.session as string) || "",
      key: (search.key as string) || "",
    })
  },
  beforeLoad: async ({ search }) => {
    if (search.qr && search.session && search.key) {
      await fetchWelcomeToken({ qrLookupID: search.qr })
      throw redirect({
        to: "/qr/$qrLookupID/gated/register/$sessionID/confirmation",
        params: { qrLookupID: search.qr, sessionID: search.session },
        search: { key: search.key },
      })
    }
    throw notFound()
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/confirmation"!</div>
}
